import React from 'react';
import { useSelector } from 'react-redux';
import {
	safeNavItems,
	getNavItemKey,
	flattenDrilldownChildren
} from '../utils/navItemUtils';

/**
 * SSRDrilldownLinks — renders flat <a> links for all drilldown children.
 * Only rendered inside the SSR fallback container (visibility: hidden,
 * aria-hidden, inert). Provides crawlable links for second-level navigation.
 *
 * @returns {React.ReactElement|null}
 */
const SSRDrilldownLinks = () => {
	const items = useSelector((state) => state.navData?.items ?? []);
	const parentItems = items.filter((item) => safeNavItems(item).length > 0);

	if (parentItems.length === 0) return null;

	return (
		<div className="ws-nav-drawer__ssr-drilldown-links">
			{parentItems.map((parent, parentIndex) => (
				<div key={getNavItemKey(parent, parentIndex)}>
					{flattenDrilldownChildren(parent).map(
						(child, childIndex) => (
							<a
								key={getNavItemKey(child, childIndex)}
								href={child.url}
							>
								{child.label}
							</a>
						)
					)}
				</div>
			))}
		</div>
	);
};

export { SSRDrilldownLinks };
